import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { ReviewProvider } from './review-context';

type ReviewBootValue = {
  reviewBootLoading: boolean;
  reviewReady: boolean;
};

const ReviewBootContext = createContext<ReviewBootValue | null>(null);

export const useReviewBoot = () => {
  const ctx = useContext(ReviewBootContext);
  if (!ctx) throw new Error('useReviewBoot must be used within ReviewBootProvider');
  return ctx;
};

export const ReviewBootProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [reviewBootLoading, setReviewBootLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    // next tick so ReviewProvider has a chance to run its mount effects
    Promise.resolve().then(() => {
      if (!cancelled) setReviewBootLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({
      reviewBootLoading,
      reviewReady: !reviewBootLoading,
    }),
    [reviewBootLoading]
  );

  return (
    <ReviewProvider>
      <ReviewBootContext.Provider value={value}>{children}</ReviewBootContext.Provider>
    </ReviewProvider>
  );
};
